// extracted by mini-css-extract-plugin
module.exports = {"root":"ZdjE7cBClffbTycjp8dQ","bannersnackEditor":"ZVE1kh2krxufbo6s7ON_"};